/**
 * @generated SignedSource<<510ca93642cf70a82828945dc6786055>>
 * @relayHash bae64e2f11d6d92dd855f6920f325fda
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bae64e2f11d6d92dd855f6920f325fda

import { ConcreteRequest } from 'relay-runtime';
export type De_createCallCaseSummaryFeedbackInput = {
  appointmentId: string;
  feedbackText: string;
};
export type deCreateCallCaseSummaryFeedbackMutation$variables = {
  input: De_createCallCaseSummaryFeedbackInput;
};
export type deCreateCallCaseSummaryFeedbackMutation$data = {
  readonly de_createCallCaseSummaryFeedback: {
    readonly callCaseSummaryFeedback: {
      readonly appointmentId: number;
      readonly createdAt: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type deCreateCallCaseSummaryFeedbackMutation = {
  response: deCreateCallCaseSummaryFeedbackMutation$data;
  variables: deCreateCallCaseSummaryFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CallCaseSummaryFeedback",
  "kind": "LinkedField",
  "name": "callCaseSummaryFeedback",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deCreateCallCaseSummaryFeedbackMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_createCallCaseSummaryFeedbackPayload",
        "kind": "LinkedField",
        "name": "de_createCallCaseSummaryFeedback",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deCreateCallCaseSummaryFeedbackMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_createCallCaseSummaryFeedbackPayload",
        "kind": "LinkedField",
        "name": "de_createCallCaseSummaryFeedback",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "bae64e2f11d6d92dd855f6920f325fda",
    "metadata": {},
    "name": "deCreateCallCaseSummaryFeedbackMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "27f26b050291cf0f729cae10fe50f2e1";

export default node;
